import { Concepto } from '../types/administracion';

/** Listado cerrado de unidades (spec §3.5) */
export const UNIDADES_MEDIDA = [
  // Peso
  'kg', 'gramos', 'toneladas',
  // Volumen
  'litros',
  // Cantidad
  'unidades',
  // Material
  'metros', 'rollos',
  // Tiempo (gastos fijos, servicios)
  'hora', 'dia', 'semana', 'mes',
] as const;

/** normalizarTexto: lowercase + trim + sin acentos + espacios colapsados (spec §5.5) */
export function normalizarTexto(texto: string): string {
  return (texto ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, ' ');
}

/** Deriva kg desde la cantidad cargada según unidad de carga (spec §3.7) */
export function kgDeCantidad(cantidad: number, concepto: Concepto): number {
  if (!concepto.unidad_carga || concepto.unidad_carga === 'kg' || !concepto.kg_por_unidad) {
    return cantidad; // ya está en unidad base
  }
  return cantidad * concepto.kg_por_unidad;
}

/** Convierte kg a unidades de carga fraccionales (spec §3.7) */
export function unidadesDesdeKg(kg: number, concepto: Concepto): number {
  if (!concepto.unidad_carga || concepto.unidad_carga === 'kg' || !concepto.kg_por_unidad) {
    return kg;
  }
  return kg / concepto.kg_por_unidad;
}

function numeroAr(n: number, decimales = 0): string {
  return n.toLocaleString('es-AR', { minimumFractionDigits: decimales, maximumFractionDigits: decimales });
}

/** "4,77 unidades (2.145 kg)" — display fraccional (spec §3.7) */
export function formatearStockFraccional(kg: number, concepto: Concepto): string {
  if (!concepto.unidad_carga || concepto.unidad_carga === 'kg' || !concepto.kg_por_unidad) {
    return `${numeroAr(kg)} kg`;
  }
  const unidades = unidadesDesdeKg(kg, concepto);
  return `${numeroAr(unidades, 2)} ${concepto.unidad_carga} (${numeroAr(kg)} kg)`;
}
